<template>
  <div>
    <!-- <van-tabs v-model="activeTab" @click="onTabsClick"> -->
    <van-overlay v-show="loading">
      <div class="loading-wrapper">
        <van-loading type="spinner" color="#fff" size="40px">加载中...</van-loading>
      </div>
    </van-overlay>
    <van-tabs v-if="login_status === 'alreadyLogin'" v-model="activeTab" sticky animated swipeable>

      <van-tab title="快捷设置" name="tab_kuaijie">
        <div class="mgt20">
          <van-field v-model="tab_kuaijie.keyword" label="追加监控词" label-width="120px" :placeholder="login_data ? '填写监控词' : '填写 K: 监控词 或 stock_code'" maxlength="50"/>
        </div>
        <div class="checkbox_zone mgt20">
          <van-checkbox v-model="tab_kuaijie.hudong_flag">互动回答</van-checkbox>
          <van-checkbox v-model="tab_kuaijie.jiucaigongshe_flag">公社标题</van-checkbox>
          <van-checkbox v-model="tab_kuaijie.tonghuashun_flag">新增概念</van-checkbox>
        </div>
        <div class="mgt20">
          <van-radio-group v-model="tab_kuaijie.wx_flag" direction="horizontal">
            <van-radio name="1">官微内容+标题</van-radio>
            <van-radio name="2">官微标题</van-radio>
            <van-radio name="0">无</van-radio>
          </van-radio-group>
        </div>
        <div class="mgt20">
          <van-radio-group v-model="tab_kuaijie.gonggao_flag" direction="horizontal">
            <van-radio name="1">公告内容+标题</van-radio>
            <van-radio name="2">公告标题</van-radio>
            <van-radio name="0">无</van-radio>
          </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
          <van-checkbox v-model="tab_kuaijie.gov_flag" v-show="!login_data">政网标题</van-checkbox>
          <van-checkbox v-model="tab_kuaijie.cailianshe_flag" v-show="!login_data">CLS</van-checkbox>
          <van-checkbox v-model="tab_kuaijie.ipo_flag" v-show="!login_data">IPO</van-checkbox>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabKuaijieSave('append')" round type="primary">确认追加</van-button>
          <van-button @click="onTabKuaijieSave('remove')" round>确认移除</van-button>
        </div>
      </van-tab>

      <van-tab title="互动搜索" name="tab_ty_hudong_search">
        <div class="checkbox_zone mgt20" v-show="login_data">
          除去<van-checkbox v-model="tab_ty_hudong_search.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20" v-show="login_data">
          仅限于<van-checkbox v-model="tab_ty_hudong_search.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_ty_hudong_search.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-row>
            <van-col span="12">
              <van-field v-model="tab_ty_hudong_search.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
            </van-col>
            <van-col span="12">
              <van-field v-model="tab_ty_hudong_search.days_enable" label="N天内回复" label-width="120px" placeholder="N天内回复" type="digit" maxlength="4"/>
            </van-col>
          </van-row>
          <van-field v-model="tab_ty_hudong_search.stock_code" v-show="login_data" label="代码" label-width="120px" placeholder="搜代码" maxlength="6"/>
          <van-field v-model="stock_name" label="名称" label-width="120px" placeholder="搜名称，可模糊查询" maxlength="10"/>
          <van-field v-model="address" label="地址" label-width="120px" placeholder="搜上市公司地址，可模糊查询" maxlength="20"/>
          <van-field v-model="tags" label="Tags" label-width="120px" placeholder="可模糊查询" maxlength="20"/>

          <van-field v-model="diejia_gn_list" @input="handleInput1" label="概念叠加" label-width="120px" placeholder="支持“+”号，搜概念名称，叠加多个概念" maxlength="100"/>
          <van-dropdown-menu v-show="show1">
            <van-dropdown-item :title='title1' @change='handelChange1' :options="option1" get-container="#app" />
          </van-dropdown-menu>

          <van-field v-model="diejia_hy_list" @input="handleInputHy1" label="申万行业叠加" label-width="120px" placeholder="支持“+”号，搜申万行业名称，叠加多个行业" maxlength="100"/>
          <van-dropdown-menu v-show="showHy1">
            <van-dropdown-item :title='titleHy1' @change='handelChangeHy1' :options="optionHy1" get-container="#app" />
          </van-dropdown-menu>

          <van-field v-model="main_business" label="主营/亮点/产品" label-width="120px" placeholder="支持“+”号，搜主营/亮点/产品，加号叠加多个关键词" maxlength="50"/>
          <van-field v-model="tab_ty_hudong_search.zhuying_percent" v-show="!login_data" label="主营占比" label-width="120px" placeholder="主营占比" maxlength="50"/>
          <van-field v-model="tab_ty_hudong_search.holder_customer" label="股东/控制/客商" label-width="120px" placeholder="支持“+”号，搜索股东/实际控制人/客户/供应商，加号叠加多个关键词" maxlength="50"/>
          <van-field v-model="tab_ty_hudong_search.waixiao_percent" v-show="!login_data" label="外销占比" label-width="120px" placeholder="外销占比" maxlength="50"/>
          <van-field v-model="gn_name" @input="handleInput2" v-show="!login_data" label="是否加入概念" label-width="120px" placeholder="概念名称" maxlength="50"/>
          <van-dropdown-menu v-show="show2">
            <van-dropdown-item :title='title2' @change='handelChange2' :options="option2" get-container="#app" />
          </van-dropdown-menu>

          <van-radio-group v-model="show_care_gn_type" direction="horizontal" v-show="!login_data">
            <van-radio name="0">全部</van-radio>
            <van-radio name="1">已加入</van-radio>
            <van-radio name="2">未加入</van-radio>
          </van-radio-group>
        </div>
        <div class="mgt20">
          <van-field v-model="search_keyword" label="回复关键词" label-width="120px" placeholder="“+”加号且，“ ”空格或，搜互动问答董秘回复关键词" maxlength="50"/>
          <van-radio-group v-model="easter_egg" direction="horizontal" v-show="!login_data">
            <van-radio name="wu">无</van-radio>
            <van-radio name="weiyi">一</van-radio>
            <van-radio name="gongyingshang">供</van-radio>
            <van-radio name="jingxiaoshang">销</van-radio>
            <van-radio name="cangu">参</van-radio>
          </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_ty_hudong_search.in_sentence" direction="horizontal">
              <van-radio name="1">句内搜索</van-radio>
              <van-radio name="0">全文搜索</van-radio>
            </van-radio-group>
            <van-checkbox v-model="tab_ty_hudong_search.filter_fouding" v-show="!login_data">去除否定的回复</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_ty_hudong_search.pub_time_sort_type" direction="horizontal" v-show="!login_data">
              <van-radio name="nearly" @click="onBtnTyHudongSearch">最近回复时间排序</van-radio>
              <van-radio name="first" @click="onBtnTyHudongSearch">首次回复时间排序</van-radio>
            </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-checkbox v-model="tab_ty_hudong_search.order_by_gn_pub_time" @click="onBtnTyHudongSearch" v-show="!login_data">概念添加时间排序</van-checkbox>
            <van-checkbox v-model="tab_ty_hudong_search.juhe">聚合展示</van-checkbox>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onBtnTyHudongReset" round type="default">重置</van-button>
          <van-button @click="onBtnTyHudongSearch" round type="primary">查询</van-button>
          <van-button @click="onBtnXindeClick" round type="primary" v-show="!login_data">心得</van-button>
        </div>
        <div class="mgt20">
            <label>{{keywords_history}}</label>
        </div>
        <div class="tip_zone mgt20">
          <div>明细数 / 主体数: {{tab_ty_hudong_search_result.total_length}} / {{tab_ty_hudong_search_result.stock_number}}
          ; 页数: {{tab_ty_hudong_search.page}} / {{Math.ceil(this.tab_ty_hudong_search_result.stock_number/this.tab_ty_hudong_search.page_size)}}</div>
          <van-radio-group v-model="tab_ty_hudong_search.sort_by" direction="horizontal">
            <van-radio name="" @click="onBtnTyHudongSearch">无</van-radio>
            <van-radio name="code" @click="onBtnTyHudongSearch">代码</van-radio>
            <van-radio name="price" @click="onBtnTyHudongSearch">价</van-radio>
            <van-radio name="capital_amount" @click="onBtnTyHudongSearch">市值</van-radio>
            <van-radio name="today_percent" @click="onBtnTyHudongSearch">涨</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_hudong_search.fast_search_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyHudongSearch">无</van-radio>
            <van-radio name="CHUANGYE" @click="onBtnTyHudongSearch">创</van-radio>
            <van-radio name="BEIJIAO" @click="onBtnTyHudongSearch" class="blue-label">北</van-radio>
            <van-radio name="KECHUANG" @click="onBtnTyHudongSearch">科创</van-radio>
            <van-radio name="YEZT" @click="onBtnTyHudongSearch" class="blue-label">昨涨</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_hudong_search.fast_filter_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyHudongSearch">全</van-radio>
            <van-radio name="WUJIU" @click="onBtnTyHudongSearch">无韭</van-radio>
            <van-radio name="YAO" @click="onBtnTyHudongSearch" class="blue-label">妖</van-radio>
            <van-radio name="XIN" @click="onBtnTyHudongSearch" class="blue-label">新</van-radio>
            <van-radio name="RENQI" @click="onBtnTyHudongSearch" class="blue-label">人气</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_hudong_search.fast_label_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyHudongSearch">无</van-radio>
            <van-radio name="DIJIA" @click="onBtnTyHudongSearch">价</van-radio>
            <van-radio name="DISHIZHI" @click="onBtnTyHudongSearch">值</van-radio>
            <van-radio name="SHUANGDI" @click="onBtnTyHudongSearch">双低</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_gonggao_search.tip" direction="horizontal" v-show="!login_data">
            <van-radio class="blue-label">亮点唯一/冠军</van-radio>
            <van-radio class="blue-label">生肖</van-radio>
            <van-radio class="blue-label">同主营</van-radio>
            <van-radio class="blue-label">最低价</van-radio>
            <van-radio class="blue-label">近期曾大涨</van-radio>
            <van-radio class="blue-label">历史同期跟涨</van-radio>
            <van-radio class="blue-label">叠加华为、北美(大客户)或国内本领域头部公司</van-radio>
          </van-radio-group>
          <div v-for="(item, index) in tab_ty_hudong_search_result.stock_list" :key="index" @click="seeTyDetail($event, index)" :class="{ 'even-item': index % 2 === 0, 'odd-item': index % 2 === 1 }">
            <div>({{(tab_ty_hudong_search.page-1)*tab_ty_hudong_search.page_size+index+1}}). {{item.stock_code}} {{item.stock_name}}
                <label v-if="item.zz_code !== ''" :style="{'color':'green'}">{{item.zz_name}} </label>
                <label v-if="item.rz_enable === 1" style="color: red">融 </label>
                <label v-if="item.is_me === 1 & item.low_price === 1" style="color: #2ab5e6">{{item.low_price_str}} </label>
                <label v-if="item.is_me === 1 & item.small_market === 1" style="color: #2ab5e6">{{item.small_market_str}} </label>
                <label v-if="item.is_me === 1 & item.fouding === 1" :style="{'color':'green'}">否定 </label>
                <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.renqi_str}} </label>
                <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yao_str}} </label>
                <label v-if="item.new_stock === 1" style="color: red">新 {{item.listing_days}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.tuishi_str}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.lian_str}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.risk_str}} </label>
                <label v-if="item.is_me === 1" class="tag-item">{{item.tags}} </label>
            </div>
            <div><label :style="{'color': item.today_percent < 0.00 ? 'green' : 'red'}">{{item.today_percent}}%</label> / {{item.today_price}} / {{item.today_flow_market_capital}} <label v-if="item.a_month_zt_count > 3 || item.a_year_zt_count > 12" style="color: red">{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label><label v-else>{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label></div>
            <div v-show="tab_ty_hudong_search.pub_time_sort_type === 'nearly'">{{item.nearly_pub_time}} {{item.length}}次 <label>点击展开</label></div>
            <div v-show="tab_ty_hudong_search.pub_time_sort_type === 'first'">{{item.first_pub_time}} {{item.length}}次 <label>点击展开</label></div>
            <div v-if="item.gn_name">{{item.gn_pub_time}} 加入 {{item.gn_name}} 概念</div>
            <div v-show="expandedIndex === index">
              <!-- <div>概念：<span v-html="item.contained_concept"></span></div> -->
              <div v-show="tab_ty_hudong_search.address">地址：<span v-html="item.address"></span></div>
              <div>亮点：<span v-html="item.light"></span></div>
              <div>主营：<span v-html="item.main_business"></span></div>
              <div v-show="tab_ty_hudong_search.main_business">产品：<span v-html="item.main_product"></span></div>
              <div v-show="tab_ty_hudong_search.main_business">产品占比：<span v-html="item.product_percent"></span></div>
              <div v-show="tab_ty_hudong_search.main_business">行业占比：<span v-html="item.industry_percent"></span></div>
              <div v-show="tab_ty_hudong_search.waixiao_percent"><span v-html="item.area_percent"></span></div>
              <p></p>
              <div v-show="tab_ty_hudong_search.holder_customer"># <span v-html="item.controller"></span></div>
              <div v-show="tab_ty_hudong_search.holder_customer"># <span v-html="item.ten_stockholder"></span></div>
              <div v-show="tab_ty_hudong_search.holder_customer"># <span v-html="item.flow_stockholder"></span></div>
              <div v-show="tab_ty_hudong_search.holder_customer"># <span v-html="item.customer"></span></div>
              <div v-show="tab_ty_hudong_search.holder_customer"># <span v-html="item.supplier"></span></div>
              <div v-show="tab_ty_hudong_search.holder_customer"># 公司：<span v-html="item.org_name"></span></div>
              <p></p>
              <div v-for="(gn_detail, gn_index_detail) in item.diejia_gn_detail_list" :key="gn_index_detail">
                <van-divider />
                <div>{{gn_detail.pub_time}} 加入 <span v-html="gn_detail.keyword"></span>: <span v-html="gn_detail.content"></span></div>
              </div>
              <div v-for="(detail, index_detail) in item.detail_list" :key="index_detail">
                <van-divider />
                <div>{{item.stock_code}} {{item.stock_name}}
                    <label v-if="item.zz_code !== ''" :style="{'color':'green'}">{{item.zz_name}} </label>
                    <label v-if="item.rz_enable === 1" style="color: red">融 </label>
                    <label v-if="item.is_me === 1 & item.low_price === 1" style="color: #2ab5e6">{{item.low_price_str}} </label>
                    <label v-if="item.is_me === 1 & item.small_market === 1" style="color: #2ab5e6">{{item.small_market_str}} </label>
                    <label v-if="item.is_me === 1 & item.fouding === 1" :style="{'color':'green'}">否定 </label>
                    <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.renqi_str}} </label>
                    <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yao_str}} </label>
                    <label v-if="item.new_stock === 1" style="color: red">新 {{item.listing_days}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.tuishi_str}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.lian_str}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.risk_str}} </label>
                    <label v-if="item.is_me === 1" class="tag-item">{{item.tags}} </label>
                </div>
                <div><label :style="{'color': item.today_percent < 0.00 ? 'green' : 'red'}">{{item.today_percent}}%</label> / {{item.today_price}} / {{item.today_flow_market_capital}} <label v-if="item.a_month_zt_count > 3 || item.a_year_zt_count > 12" style="color: red">{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label><label v-else>{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label></div>
                <div>{{detail.pub_time}} <span v-html="detail.content"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip_zone mgt20">
          <div>明细数 / 主体数: {{tab_ty_hudong_search_result.total_length}} / {{tab_ty_hudong_search_result.stock_number}}
          ; 页数: {{tab_ty_hudong_search.page}} / {{Math.ceil(this.tab_ty_hudong_search_result.stock_number/this.tab_ty_hudong_search.page_size)}}</div>
        </div>
        <div v-show="!login_data" v-html="tab_ty_hudong_search_result.analysis_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[1]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[2]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[3]">
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onBtnTyHudongSearch_FirstPage" round type="default">首页</van-button>
          <van-button @click="onBtnTyHudongSearch_PrePage" round type="default">上一页</van-button>
          <van-button @click="onBtnTyHudongSearch_NextPage" round type="default">下一页</van-button>
          <van-button @click="onBtnTyHudongSearch_LastPage" round type="default">尾页</van-button>
        </div>
        <div v-show="!login_data">
        +++++++++++++++++++++++++++++++++++
        </div>
        <div v-show="!login_data" v-html="tab_ty_hudong_search_result.analysis_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[1]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[2]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[3]">
        </div>
        <div v-show="!login_data">
        +++++++++++++++++++++++++++++++++++
        </div>
      </van-tab>

      <van-tab title="公众号搜索" name="tab_ty_wx_search">
        <div class="checkbox_zone mgt20" v-show="login_data">
          除去<van-checkbox v-model="tab_ty_wx_search.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20" v-show="login_data">
          仅限于<van-checkbox v-model="tab_ty_wx_search.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_ty_wx_search.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-row>
            <van-col span="12">
              <van-field v-model="tab_ty_wx_search.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
            </van-col>
            <van-col span="12">
              <van-field v-model="tab_ty_wx_search.days_enable" label="N天内文章" label-width="120px" placeholder="N天内文章" type="digit" maxlength="4"/>
            </van-col>
          </van-row>
          <van-field v-model="tab_ty_wx_search.stock_code" v-show="login_data" label="代码" label-width="120px" placeholder="搜代码" maxlength="6"/>
          <van-field v-model="stock_name" label="名称" label-width="120px" placeholder="搜名称，可模糊查询" maxlength="10"/>
          <van-field v-model="address" label="地址" label-width="120px" placeholder="搜上市公司地址，可模糊查询" maxlength="20"/>
          <van-field v-model="tags" label="Tags" label-width="120px" placeholder="可模糊查询" maxlength="20"/>

          <van-field v-model="diejia_gn_list" @input="handleInput1" label="概念叠加" label-width="120px" placeholder="支持“+”号，搜概念名称，叠加多个概念" maxlength="100"/>
          <van-dropdown-menu v-show="show1">
            <van-dropdown-item :title='title1' @change='handelChange1' :options="option1" get-container="#app" />
          </van-dropdown-menu>

          <van-field v-model="diejia_hy_list" @input="handleInputHy1" label="申万行业叠加" label-width="120px" placeholder="支持“+”号，搜申万行业名称，叠加多个行业" maxlength="100"/>
          <van-dropdown-menu v-show="showHy1">
            <van-dropdown-item :title='titleHy1' @change='handelChangeHy1' :options="optionHy1" get-container="#app" />
          </van-dropdown-menu>

          <van-field v-model="main_business" label="主营/亮点/产品" label-width="120px" placeholder="支持“+”号，搜主营/亮点/产品，加号叠加多个关键词" maxlength="50"/>
          <van-field v-model="tab_ty_wx_search.zhuying_percent" v-show="!login_data" label="主营占比" label-width="120px" placeholder="主营占比" maxlength="50"/>
          <van-field v-model="tab_ty_wx_search.holder_customer" label="股东/控制/客商" label-width="120px" placeholder="支持“+”号，搜索股东/实际控制人/客户/供应商，加号叠加多个关键词" maxlength="50"/>
          <van-field v-model="tab_ty_wx_search.waixiao_percent" v-show="!login_data" label="外销占比" label-width="120px" placeholder="外销占比" maxlength="50"/>
          <van-field v-model="gn_name" @input="handleInput2" v-show="!login_data" label="是否加入概念" label-width="120px" placeholder="概念名称" maxlength="50"/>
          <van-dropdown-menu v-show="show2">
            <van-dropdown-item :title='title2' @change='handelChange2' :options="option2" get-container="#app" />
          </van-dropdown-menu>

          <van-radio-group v-model="show_care_gn_type" direction="horizontal" v-show="!login_data">
            <van-radio name="0">全部</van-radio>
            <van-radio name="1">已加入</van-radio>
            <van-radio name="2">未加入</van-radio>
          </van-radio-group>
        </div>
        <div class="mgt20">
          <van-field v-model="search_keyword" label="公众号文章标题或正文关键词" label-width="120px" placeholder="“+”加号且，“ ”空格或" maxlength="50"/>
          <van-radio-group v-model="easter_egg" direction="horizontal" v-show="!login_data">
            <van-radio name="wu">无</van-radio>
            <van-radio name="weiyi">一</van-radio>
            <van-radio name="gongyingshang">供</van-radio>
            <van-radio name="jingxiaoshang">销</van-radio>
            <van-radio name="cangu">参</van-radio>
          </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_ty_wx_search.in_sentence" direction="horizontal">
              <van-radio name="1">句内搜索</van-radio>
              <van-radio name="0">全文搜索</van-radio>
            </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_ty_wx_search.pub_time_sort_type" direction="horizontal" v-show="!login_data">
              <van-radio name="nearly" @click="onBtnTyWxSearch">最近发布时间排序</van-radio>
              <van-radio name="first" @click="onBtnTyWxSearch">首次发布时间排序</van-radio>
            </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-checkbox v-model="tab_ty_wx_search.order_by_gn_pub_time" @click="onBtnTyWxSearch" v-show="!login_data">概念添加时间排序</van-checkbox>
            <van-checkbox v-model="tab_ty_wx_search.juhe">聚合展示</van-checkbox>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onBtnTyWxReset" round type="default">重置</van-button>
          <van-button @click="onBtnTyWxSearch" round type="primary">查询</van-button>
          <van-button @click="onBtnXindeClick" round type="primary" v-show="!login_data">心得</van-button>
        </div>
        <div class="mgt20">
            <label>{{keywords_history}}</label>
        </div>
        <div class="tip_zone mgt20">
          <div>明细数 / 主体数: {{tab_ty_wx_search_result.total_length}} / {{tab_ty_wx_search_result.stock_number}}
          ; 页数: {{tab_ty_wx_search.page}} / {{Math.ceil(this.tab_ty_wx_search_result.stock_number/this.tab_ty_wx_search.page_size)}}</div>
          <van-radio-group v-model="tab_ty_wx_search.sort_by" direction="horizontal">
            <van-radio name="" @click="onBtnTyWxSearch">无</van-radio>
            <van-radio name="code" @click="onBtnTyWxSearch">代码</van-radio>
            <van-radio name="price" @click="onBtnTyWxSearch">价</van-radio>
            <van-radio name="capital_amount" @click="onBtnTyWxSearch">市值</van-radio>
            <van-radio name="today_percent" @click="onBtnTyWxSearch">涨</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_wx_search.fast_search_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyWxSearch">无</van-radio>
            <van-radio name="CHUANGYE" @click="onBtnTyWxSearch">创</van-radio>
            <van-radio name="BEIJIAO" @click="onBtnTyWxSearch" class="blue-label">北</van-radio>
            <van-radio name="KECHUANG" @click="onBtnTyWxSearch">科创</van-radio>
            <van-radio name="YEZT" @click="onBtnTyWxSearch" class="blue-label">昨涨</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_wx_search.fast_filter_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyWxSearch">全</van-radio>
            <van-radio name="Only1" @click="onBtnTyWxSearch" class="blue-label">仅1条</van-radio>
            <van-radio name="YAO" @click="onBtnTyWxSearch" class="blue-label">妖</van-radio>
            <van-radio name="XIN" @click="onBtnTyWxSearch" class="blue-label">新</van-radio>
            <van-radio name="RENQI" @click="onBtnTyWxSearch" class="blue-label">人气</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_wx_search.fast_label_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyWxSearch">无</van-radio>
            <van-radio name="DIJIA" @click="onBtnTyWxSearch">价</van-radio>
            <van-radio name="DISHIZHI" @click="onBtnTyWxSearch">值</van-radio>
            <van-radio name="SHUANGDI" @click="onBtnTyWxSearch">双低</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_gonggao_search.tip" direction="horizontal" v-show="!login_data">
            <van-radio class="blue-label">亮点唯一/冠军</van-radio>
            <van-radio class="blue-label">生肖</van-radio>
            <van-radio class="blue-label">同主营</van-radio>
            <van-radio class="blue-label">最低价</van-radio>
            <van-radio class="blue-label">近期曾大涨</van-radio>
            <van-radio class="blue-label">历史同期跟涨</van-radio>
            <van-radio class="blue-label">叠加华为、北美(大客户)或国内本领域头部公司</van-radio>
          </van-radio-group>
          <div v-for="(item, index) in tab_ty_wx_search_result.stock_list" :key="index" @click="seeTyDetail($event, index)" :class="{ 'even-item': index % 2 === 0, 'odd-item': index % 2 === 1 }">
            <div>({{(tab_ty_wx_search.page-1)*tab_ty_wx_search.page_size+index+1}}). {{item.stock_code}} {{item.stock_name}}
                <label v-if="item.zz_code !== ''" :style="{'color':'green'}">{{item.zz_name}} </label>
                <label v-if="item.rz_enable === 1" style="color: red">融 </label>
                <label v-if="item.is_me === 1 & item.low_price === 1" style="color: #2ab5e6">{{item.low_price_str}} </label>
                <label v-if="item.is_me === 1 & item.small_market === 1" style="color: #2ab5e6">{{item.small_market_str}} </label>
                <label v-if="item.is_me === 1 & item.fouding === 1" :style="{'color':'green'}">否定 </label>
                <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.renqi_str}} </label>
                <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yao_str}} </label>
                <label v-if="item.new_stock === 1" style="color: red">新 {{item.listing_days}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.tuishi_str}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.lian_str}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.risk_str}} </label>
                <label v-if="item.is_me === 1" class="tag-item">{{item.tags}} </label>
            </div>
            <div><label :style="{'color': item.today_percent < 0.00 ? 'green' : 'red'}">{{item.today_percent}}%</label> / {{item.today_price}} / {{item.today_flow_market_capital}} <label v-if="item.a_month_zt_count > 3 || item.a_year_zt_count > 12" style="color: red">{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label><label v-else>{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label></div>
            <div v-show="tab_ty_wx_search.pub_time_sort_type === 'nearly'">{{item.nearly_pub_time}} {{item.length}}次 <label>点击展开</label></div>
            <div v-show="tab_ty_wx_search.pub_time_sort_type === 'first'">{{item.first_pub_time}} {{item.length}}次 <label>点击展开</label></div>
            <div v-if="item.gn_name">{{item.gn_pub_time}} 加入 {{item.gn_name}} 概念</div>
            <div v-show="expandedIndex === index">
              <!-- <div>概念：<span v-html="item.contained_concept"></span></div> -->
              <div v-show="tab_ty_wx_search.address">地址：<span v-html="item.address"></span></div>
              <div>亮点：<span v-html="item.light"></span></div>
              <div>主营：<span v-html="item.main_business"></span></div>
              <div v-show="tab_ty_wx_search.main_business">产品：<span v-html="item.main_product"></span></div>
              <div v-show="tab_ty_wx_search.main_business">产品占比：<span v-html="item.product_percent"></span></div>
              <div v-show="tab_ty_wx_search.main_business">行业占比：<span v-html="item.industry_percent"></span></div>
              <div v-show="tab_ty_wx_search.waixiao_percent"><span v-html="item.area_percent"></span></div>
              <p></p>
              <div v-show="tab_ty_wx_search.holder_customer"># <span v-html="item.controller"></span></div>
              <div v-show="tab_ty_wx_search.holder_customer"># <span v-html="item.ten_stockholder"></span></div>
              <div v-show="tab_ty_wx_search.holder_customer"># <span v-html="item.flow_stockholder"></span></div>
              <div v-show="tab_ty_wx_search.holder_customer"># <span v-html="item.customer"></span></div>
              <div v-show="tab_ty_wx_search.holder_customer"># <span v-html="item.supplier"></span></div>
              <div v-show="tab_ty_wx_search.holder_customer"># 公司：<span v-html="item.org_name"></span></div>
              <p></p>
              <div v-for="(gn_detail, gn_index_detail) in item.diejia_gn_detail_list" :key="gn_index_detail">
                <van-divider />
                <div>{{gn_detail.pub_time}} 加入 <span v-html="gn_detail.keyword"></span>: <span v-html="gn_detail.content"></span></div>
              </div>
              <div v-for="(detail, index_detail) in item.detail_list" :key="index_detail">
                <van-divider />
                <div>{{item.stock_code}} {{item.stock_name}}
                    <label v-if="item.zz_code !== ''" :style="{'color':'green'}">{{item.zz_name}} </label>
                    <label v-if="item.rz_enable === 1" style="color: red">融 </label>
                    <label v-if="item.is_me === 1 & item.low_price === 1" style="color: #2ab5e6">{{item.low_price_str}} </label>
                    <label v-if="item.is_me === 1 & item.small_market === 1" style="color: #2ab5e6">{{item.small_market_str}} </label>
                    <label v-if="item.is_me === 1 & item.fouding === 1" :style="{'color':'green'}">否定 </label>
                    <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.renqi_str}} </label>
                    <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yao_str}} </label>
                    <label v-if="item.new_stock === 1" style="color: red">新 {{item.listing_days}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.tuishi_str}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.lian_str}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.risk_str}} </label>
                    <label v-if="item.is_me === 1" class="tag-item">{{item.tags}} </label>
                </div>
                <div><label :style="{'color': item.today_percent < 0.00 ? 'green' : 'red'}">{{item.today_percent}}%</label> / {{item.today_price}} / {{item.today_flow_market_capital}} <label v-if="item.a_month_zt_count > 3 || item.a_year_zt_count > 12" style="color: red">{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label><label v-else>{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label></div>
                <div>{{detail.pub_time}} 《<span v-html="detail.title"></span>》<a :href="detail.link" target="_blank">查看原文</a></div>
                <div><span v-html="detail.content"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip_zone mgt20">
          <div>明细数 / 主体数: {{tab_ty_wx_search_result.total_length}} / {{tab_ty_wx_search_result.stock_number}}
          ; 页数: {{tab_ty_wx_search.page}} / {{Math.ceil(this.tab_ty_wx_search_result.stock_number/this.tab_ty_wx_search.page_size)}}</div>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onBtnTyWxSearch_FirstPage" round type="default">首页</van-button>
          <van-button @click="onBtnTyWxSearch_PrePage" round type="default">上一页</van-button>
          <van-button @click="onBtnTyWxSearch_NextPage" round type="default">下一页</van-button>
          <van-button @click="onBtnTyWxSearch_LastPage" round type="default">尾页</van-button>
        </div>
        <div v-show="!login_data">
        +++++++++++++++++++++++++++++++++++
        </div>
        <div v-show="!login_data" v-html="tab_ty_wx_search_result.analysis_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[1]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[2]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[3]">
        </div>
        <div v-show="!login_data">
        +++++++++++++++++++++++++++++++++++
        </div>
      </van-tab>

      <van-tab title="公告搜索" name="tab_ty_gonggao_search">
        <div class="checkbox_zone mgt20" v-show="login_data">
          除去<van-checkbox v-model="tab_ty_gonggao_search.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20" v-show="login_data">
          仅限于<van-checkbox v-model="tab_ty_gonggao_search.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_ty_gonggao_search.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-row>
            <van-col span="12">
              <van-field v-model="tab_ty_gonggao_search.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
            </van-col>
            <van-col span="12">
              <van-field v-model="tab_ty_gonggao_search.days_enable" label="N天内公告" label-width="120px" placeholder="N天内公告" type="digit" maxlength="4"/>
            </van-col>
          </van-row>
          <van-field v-model="tab_ty_gonggao_search.stock_code" v-show="login_data" label="代码" label-width="120px" placeholder="搜代码" maxlength="6"/>
          <van-field v-model="stock_name" label="名称" label-width="120px" placeholder="搜名称，可模糊查询" maxlength="10"/>
          <van-field v-model="address" label="地址" label-width="120px" placeholder="搜上市公司地址，可模糊查询" maxlength="20"/>
          <van-field v-model="tags" label="Tags" label-width="120px" placeholder="可模糊查询" maxlength="20"/>

          <van-field v-model="diejia_gn_list" @input="handleInput1" label="概念叠加" label-width="120px" placeholder="支持“+”号，搜概念名称，叠加多个概念" maxlength="100"/>
          <van-dropdown-menu v-show="show1">
            <van-dropdown-item :title='title1' @change='handelChange1' :options="option1" get-container="#app" />
          </van-dropdown-menu>

          <van-field v-model="diejia_hy_list" @input="handleInputHy1" label="申万行业叠加" label-width="120px" placeholder="支持“+”号，搜申万行业名称，叠加多个行业" maxlength="100"/>
          <van-dropdown-menu v-show="showHy1">
            <van-dropdown-item :title='titleHy1' @change='handelChangeHy1' :options="optionHy1" get-container="#app" />
          </van-dropdown-menu>

          <van-field v-model="main_business" label="主营/亮点/产品" label-width="120px" placeholder="支持“+”号，搜主营/亮点/产品，加号叠加多个关键词" maxlength="50"/>
          <van-field v-model="tab_ty_gonggao_search.zhuying_percent" v-show="!login_data" label="主营占比" label-width="120px" placeholder="主营占比" maxlength="50"/>
          <van-field v-model="tab_ty_gonggao_search.holder_customer" label="股东/控制/客商" label-width="120px" placeholder="支持“+”号，搜索股东/实际控制人/客户/供应商，加号叠加多个关键词" maxlength="50"/>
          <van-field v-model="tab_ty_gonggao_search.waixiao_percent" v-show="!login_data" label="外销占比" label-width="120px" placeholder="外销占比" maxlength="50"/>
          <van-field v-model="gn_name" @input="handleInput2" v-show="!login_data" label="是否加入概念" label-width="120px" placeholder="概念名称" maxlength="50"/>
          <van-dropdown-menu v-show="show2">
            <van-dropdown-item :title='title2' @change='handelChange2' :options="option2" get-container="#app" />
          </van-dropdown-menu>

          <van-radio-group v-model="show_care_gn_type" direction="horizontal" v-show="!login_data">
            <van-radio name="0">全部</van-radio>
            <van-radio name="1">已加入</van-radio>
            <van-radio name="2">未加入</van-radio>
          </van-radio-group>
        </div>
        <div class="mgt20">
          <van-field v-model="search_keyword" label="公告标题或正文关键词" label-width="120px" placeholder="“+”加号且，“ ”空格或" maxlength="50"/>
          <van-radio-group v-model="easter_egg" direction="horizontal" v-show="!login_data">
            <van-radio name="wu">无</van-radio>
            <van-radio name="weiyi">一</van-radio>
            <van-radio name="gongyingshang">供</van-radio>
            <van-radio name="jingxiaoshang">销</van-radio>
            <van-radio name="cangu">参</van-radio>
          </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_ty_gonggao_search.in_sentence" direction="horizontal">
              <van-radio name="1">句内搜索</van-radio>
              <van-radio name="0">全文搜索</van-radio>
            </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_ty_gonggao_search.pub_time_sort_type" direction="horizontal" v-show="!login_data">
              <van-radio name="nearly" @click="onBtnTyGonggaoSearch">最近发布时间排序</van-radio>
              <van-radio name="first" @click="onBtnTyGonggaoSearch">首次发布时间排序</van-radio>
            </van-radio-group>
        </div>
        <div class="checkbox_zone mgt20">
            <van-checkbox v-model="tab_ty_gonggao_search.order_by_gn_pub_time" @click="onBtnTyGonggaoSearch" v-show="!login_data">概念添加时间排序</van-checkbox>
            <van-checkbox v-model="tab_ty_gonggao_search.juhe">聚合展示</van-checkbox>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onBtnTyGonggaoReset" round type="default">重置</van-button>
          <van-button @click="onBtnTyGonggaoSearch" round type="primary">查询</van-button>
          <van-button @click="onBtnXindeClick" round type="primary" v-show="!login_data">心得</van-button>
        </div>
        <div class="mgt20">
            <label>{{keywords_history}}</label>
        </div>
        <div class="tip_zone mgt20">
          <div>明细数 / 主体数: {{tab_ty_gonggao_search_result.total_length}} / {{tab_ty_gonggao_search_result.stock_number}}
          ; 页数: {{tab_ty_gonggao_search.page}} / {{Math.ceil(this.tab_ty_gonggao_search_result.stock_number/this.tab_ty_gonggao_search.page_size)}}</div>
          <van-radio-group v-model="tab_ty_gonggao_search.sort_by" direction="horizontal">
            <van-radio name="" @click="onBtnTyGonggaoSearch">无</van-radio>
            <van-radio name="code" @click="onBtnTyGonggaoSearch">代码</van-radio>
            <van-radio name="price" @click="onBtnTyGonggaoSearch">价</van-radio>
            <van-radio name="capital_amount" @click="onBtnTyGonggaoSearch">市值</van-radio>
            <van-radio name="today_percent" @click="onBtnTyGonggaoSearch">涨</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_gonggao_search.fast_search_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyGonggaoSearch">无</van-radio>
            <van-radio name="CHUANGYE" @click="onBtnTyGonggaoSearch">创</van-radio>
            <van-radio name="BEIJIAO" @click="onBtnTyGonggaoSearch" class="blue-label">北</van-radio>
            <van-radio name="KECHUANG" @click="onBtnTyGonggaoSearch">科创</van-radio>
            <van-radio name="YEZT" @click="onBtnTyGonggaoSearch" class="blue-label">昨涨</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_gonggao_search.fast_filter_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyGonggaoSearch">全</van-radio>
            <van-radio name="YAO" @click="onBtnTyGonggaoSearch" class="blue-label">妖</van-radio>
            <van-radio name="XIN" @click="onBtnTyGonggaoSearch" class="blue-label">新</van-radio>
            <van-radio name="RENQI" @click="onBtnTyGonggaoSearch" class="blue-label">人气</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_gonggao_search.fast_label_type" direction="horizontal" v-show="!login_data">
            <van-radio name="" @click="onBtnTyGonggaoSearch">无</van-radio>
            <van-radio name="DIJIA" @click="onBtnTyGonggaoSearch">价</van-radio>
            <van-radio name="DISHIZHI" @click="onBtnTyGonggaoSearch">值</van-radio>
            <van-radio name="SHUANGDI" @click="onBtnTyGonggaoSearch">双低</van-radio>
          </van-radio-group>
          <van-radio-group v-model="tab_ty_gonggao_search.tip" direction="horizontal" v-show="!login_data">
            <van-radio class="blue-label">亮点唯一/冠军</van-radio>
            <van-radio class="blue-label">生肖</van-radio>
            <van-radio class="blue-label">同主营</van-radio>
            <van-radio class="blue-label">最低价</van-radio>
            <van-radio class="blue-label">近期曾大涨</van-radio>
            <van-radio class="blue-label">历史同期跟涨</van-radio>
            <van-radio class="blue-label">叠加华为、北美(大客户)或国内本领域头部公司</van-radio>
          </van-radio-group>
          <div v-for="(item, index) in tab_ty_gonggao_search_result.stock_list" :key="index" @click="seeTyDetail($event, index)" :class="{ 'even-item': index % 2 === 0, 'odd-item': index % 2 === 1 }">
            <div>({{(tab_ty_gonggao_search.page-1)*tab_ty_gonggao_search.page_size+index+1}}). {{item.stock_code}} {{item.stock_name}}
                <label v-if="item.zz_code !== ''" :style="{'color':'green'}">{{item.zz_name}} </label>
                <label v-if="item.rz_enable === 1" style="color: red">融 </label>
                <label v-if="item.is_me === 1 & item.low_price === 1" style="color: #2ab5e6">{{item.low_price_str}} </label>
                <label v-if="item.is_me === 1 & item.small_market === 1" style="color: #2ab5e6">{{item.small_market_str}} </label>
                <label v-if="item.is_me === 1 & item.fouding === 1" :style="{'color':'green'}">否定 </label>
                <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.renqi_str}} </label>
                <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yao_str}} </label>
                <label v-if="item.new_stock === 1" style="color: red">新 {{item.listing_days}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.tuishi_str}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.lian_str}} </label>
                <label v-if="item.is_me === 1" style="color: red">{{item.risk_str}} </label>
                <label v-if="item.is_me === 1" class="tag-item">{{item.tags}} </label>
            </div>
            <div><label :style="{'color': item.today_percent < 0.00 ? 'green' : 'red'}">{{item.today_percent}}%</label> / {{item.today_price}} / {{item.today_flow_market_capital}} <label v-if="item.a_month_zt_count > 3 || item.a_year_zt_count > 12" style="color: red">{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label><label v-else>{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label></div>
            <div v-show="tab_ty_gonggao_search.pub_time_sort_type === 'nearly'">{{item.nearly_pub_time}} {{item.length}}次 <label>点击展开</label></div>
            <div v-show="tab_ty_gonggao_search.pub_time_sort_type === 'first'">{{item.first_pub_time}} {{item.length}}次 <label>点击展开</label></div>
            <div v-if="item.gn_name">{{item.gn_pub_time}} 加入 {{item.gn_name}} 概念</div>
            <div v-show="expandedIndex === index">
              <!-- <div>概念：<span v-html="item.contained_concept"></span></div> -->
              <div v-show="tab_ty_gonggao_search.address">地址：<span v-html="item.address"></span></div>
              <div>亮点：<span v-html="item.light"></span></div>
              <div>主营：<span v-html="item.main_business"></span></div>
              <div v-show="tab_ty_gonggao_search.main_business">产品：<span v-html="item.main_product"></span></div>
              <div v-show="tab_ty_gonggao_search.main_business">产品占比：<span v-html="item.product_percent"></span></div>
              <div v-show="tab_ty_gonggao_search.main_business">行业占比：<span v-html="item.industry_percent"></span></div>
              <div v-show="tab_ty_gonggao_search.waixiao_percent"><span v-html="item.area_percent"></span></div>
              <p></p>
              <div v-show="tab_ty_gonggao_search.holder_customer"># <span v-html="item.controller"></span></div>
              <div v-show="tab_ty_gonggao_search.holder_customer"># <span v-html="item.ten_stockholder"></span></div>
              <div v-show="tab_ty_gonggao_search.holder_customer"># <span v-html="item.flow_stockholder"></span></div>
              <div v-show="tab_ty_gonggao_search.holder_customer"># <span v-html="item.customer"></span></div>
              <div v-show="tab_ty_gonggao_search.holder_customer"># <span v-html="item.supplier"></span></div>
              <div v-show="tab_ty_gonggao_search.holder_customer"># 公司：<span v-html="item.org_name"></span></div>
              <p></p>
              <div v-for="(gn_detail, gn_index_detail) in item.diejia_gn_detail_list" :key="gn_index_detail">
                <van-divider />
                <div>{{gn_detail.pub_time}} 加入 <span v-html="gn_detail.keyword"></span>: <span v-html="gn_detail.content"></span></div>
              </div>
              <div v-for="(detail, index_detail) in item.detail_list" :key="index_detail">
                <van-divider />
                <div>{{item.stock_code}} {{item.stock_name}}
                    <label v-if="item.zz_code !== ''" :style="{'color':'green'}">{{item.zz_name}} </label>
                    <label v-if="item.rz_enable === 1" style="color: red">融 </label>
                    <label v-if="item.is_me === 1 & item.low_price === 1" style="color: #2ab5e6">{{item.low_price_str}} </label>
                    <label v-if="item.is_me === 1 & item.small_market === 1" style="color: #2ab5e6">{{item.small_market_str}} </label>
                    <label v-if="item.is_me === 1 & item.fouding === 1" :style="{'color':'green'}">否定 </label>
                    <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yrenqi_str}} </label>
                    <label v-if="item.is_me === 1" style="color: #2ab5e6">{{item.yao_str}} </label>
                    <label v-if="item.new_stock === 1" style="color: red">新 {{item.listing_days}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.tuishi_str}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.lian_str}} </label>
                    <label v-if="item.is_me === 1" style="color: red">{{item.risk_str}} </label>
                    <label v-if="item.is_me === 1" class="tag-item">{{item.tags}} </label>
                </div>
                <div><label :style="{'color': item.today_percent < 0.00 ? 'green' : 'red'}">{{item.today_percent}}%</label> / {{item.today_price}} / {{item.today_flow_market_capital}} <label v-if="item.a_month_zt_count > 3 || item.a_year_zt_count > 12" style="color: red">{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label><label v-else>{{item.a_month_zt_count}}/{{item.a_year_zt_count}} </label></div>
                <div>{{detail.pub_time}} 《<span v-html="detail.title"></span>》<a :href="detail.link" target="_blank" v-show="!login_data">查看原文</a></div>
                <div><span v-html="detail.content"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip_zone mgt20">
          <div>明细数 / 主体数: {{tab_ty_gonggao_search_result.total_length}} / {{tab_ty_gonggao_search_result.stock_number}}
          ; 页数: {{tab_ty_gonggao_search.page}} / {{Math.ceil(this.tab_ty_gonggao_search_result.stock_number/this.tab_ty_gonggao_search.page_size)}}</div>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onBtnTyGonggaoSearch_FirstPage" round type="default">首页</van-button>
          <van-button @click="onBtnTyGonggaoSearch_PrePage" round type="default">上一页</van-button>
          <van-button @click="onBtnTyGonggaoSearch_NextPage" round type="default">下一页</van-button>
          <van-button @click="onBtnTyGonggaoSearch_LastPage" round type="default">尾页</van-button>
        </div>
        <div v-show="!login_data">
        +++++++++++++++++++++++++++++++++++
        </div>
        <div v-show="!login_data" v-html="tab_ty_gonggao_search_result.analysis_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[0]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[1]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[2]">
        </div>
        <div v-show="!login_data" v-html="xinde_result[3]">
        </div>
        <div v-show="!login_data">
        +++++++++++++++++++++++++++++++++++
        </div>
      </van-tab>

      <van-tab title="互动提醒" name="tab_hudong">
        <div class="checkbox_zone mgt20" v-show="login_data">
          除去<van-checkbox v-model="tab_hudong.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_hudong.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_hudong.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_hudong.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_hudong.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20" v-show="login_data">
          仅限于<van-checkbox v-model="tab_hudong.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_hudong.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_hudong.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_hudong.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-row>
            <van-col span="12">
              <van-field v-model="tab_hudong.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
            </van-col>
            <van-col span="12">
              <van-field v-model="tab_hudong.days_enable" label="N天内回复" label-width="120px" placeholder="N天内回复" type="digit" maxlength="4"/>
            </van-col>
          </van-row>
        </div>
        <div class="mgt20">
          <van-field v-for="(item, index) in tab_hudong.keywords" v-model="tab_hudong.keywords[index]" :key="index"
                     :label="`董秘回复关键词${index+1}`" label-width="120px" placeholder="支持“+”、“ ”、自选股代码" maxlength="20" right-icon="cross"
                     @click-right-icon="removeInput(tab_hudong.keywords, index)" @input="onInput(tab_hudong.keywords, index)"/>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_hudong.in_sentence" direction="horizontal">
              <van-radio name="1">句内搜索</van-radio>
              <van-radio name="0">全文搜索</van-radio>
            </van-radio-group>
        </div>
        <div class="add_input" v-if="tab_hudong.keywords.length < 99">
            <span @click="addInput(tab_hudong.keywords)">添加一组</span>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabHudongSave" round type="primary">保存</van-button>
          <van-button @click="onTabHudongCancel"  round type="default">取消</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>声明：</div>
          <div>1.实时监控互联网数据，当有符合监控条件的数据时，将推送到你的电脑和手机进行提醒。</div>
          <div>2.目前，可免费配置的关键词上限为9个。如不够，请联系管理员增加。</div>
        </div>
      </van-tab>

      <van-tab title="公众号提醒" name="tab_wx">
        <div class="checkbox_zone mgt20" v-show="login_data">
          除去<van-checkbox v-model="tab_wx.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_wx.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_wx.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_wx.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_wx.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20" v-show="login_data">
          仅限于<van-checkbox v-model="tab_wx.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_wx.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_wx.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_wx.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-row>
            <van-col span="12">
              <van-field v-model="tab_wx.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
            </van-col>
            <van-col span="12">
              <van-field v-model="tab_wx.days_enable" label="N天内文章" label-width="120px" placeholder="N天内文章" type="digit" maxlength="4"/>
            </van-col>
          </van-row>
        </div>
        <div class="mgt20">
          <van-field v-for="(item, index) in tab_wx.keywords" v-model="tab_wx.keywords[index]" :key="index"
                     :label="`文章标题或正文关键词${index+1}`" label-width="120px" placeholder="支持“+”、“ ”、自选股代码" maxlength="20" right-icon="cross"
                     @click-right-icon="removeInput(tab_wx.keywords, index)" @input="onInput(tab_wx.keywords, index)"/>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_wx.in_sentence" direction="horizontal">
              <van-radio name="1">句内搜索</van-radio>
              <van-radio name="0">全文搜索</van-radio>
            </van-radio-group>
        </div>
        <div class="add_input" v-if="tab_wx.keywords.length < 99">
            <span @click="addInput(tab_wx.keywords)">添加一组</span>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabWxSave" round type="primary">保存</van-button>
          <van-button @click="onTabWxCancel"  round type="default">取消</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>声明：</div>
          <div>1.实时监控互联网数据，当有符合监控条件的数据时，将推送到你的电脑和手机进行提醒。</div>
          <div>2.目前，可免费配置的关键词上限为9个。如不够，请联系管理员增加。</div>
        </div>
      </van-tab>

      <van-tab title="公告提醒" name="tab_gonggao">
        <div class="checkbox_zone mgt20" v-show="login_data">
          除去<van-checkbox v-model="tab_gonggao.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_gonggao.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_gonggao.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_gonggao.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_gonggao.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20" v-show="login_data">
          仅限于<van-checkbox v-model="tab_gonggao.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_gonggao.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_gonggao.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_gonggao.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-row>
            <van-col span="12">
              <van-field v-model="tab_gonggao.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
            </van-col>
            <van-col span="12">
              <van-field v-model="tab_gonggao.days_enable" label="N天内公告" label-width="120px" placeholder="N天内公告" type="digit" maxlength="4"/>
            </van-col>
          </van-row>
        </div>
        <div class="mgt20">
          <van-field v-for="(item, index) in tab_gonggao.keywords" v-model="tab_gonggao.keywords[index]" :key="index"
                     :label="`公告标题或正文关键词${index+1}`" label-width="120px" placeholder="支持“+”、“ ”、自选股代码" maxlength="20" right-icon="cross"
                     @click-right-icon="removeInput(tab_gonggao.keywords, index)" @input="onInput(tab_gonggao.keywords, index)"/>
        </div>
        <div class="checkbox_zone mgt20">
            <van-radio-group v-model="tab_gonggao.in_sentence" direction="horizontal">
              <van-radio name="1">句内搜索</van-radio>
              <van-radio name="0">全文搜索</van-radio>
            </van-radio-group>
        </div>
        <div class="add_input" v-if="tab_gonggao.keywords.length < 99">
            <span @click="addInput(tab_gonggao.keywords)">添加一组</span>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabGonggaoSave" round type="primary">保存</van-button>
          <van-button @click="onTabGonggaoCancel"  round type="default">取消</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>声明：</div>
          <div>1.实时监控互联网数据，当有符合监控条件的数据时，将推送到你的电脑和手机进行提醒。</div>
          <div>2.目前，可免费配置的关键词上限为9个。如不够，请联系管理员增加。</div>
        </div>
      </van-tab>

      <van-tab title="韭菜公社提醒" name="tab_jiucaigongshe">
        <div class="mgt20">
          <van-field v-model="tab_jiucaigongshe.days_enable" label="N天内文章" label-width="120px" placeholder="N天内文章" type="digit" maxlength="4"/>
        </div>
        <div class="mgt20">
          <van-field v-for="(item, index) in tab_jiucaigongshe.keywords" v-model="tab_jiucaigongshe.keywords[index]" :key="index"
                     :label="`作者标题关键词${index+1}`" label-width="120px" placeholder="输入作者或标题关键词" maxlength="20" right-icon="cross"
                     @click-right-icon="removeInput(tab_jiucaigongshe.keywords, index)" @input="onInput(tab_jiucaigongshe.keywords, index)"/>
        </div>
        <div class="add_input" v-if="tab_jiucaigongshe.keywords.length < 99">
            <span @click="addInput(tab_jiucaigongshe.keywords)">添加一组</span>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabJiucaiGongsheSave" round type="primary">保存</van-button>
          <van-button @click="onTabJiucaiGongsheCancel"  round type="default">取消</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>声明：</div>
          <div>1.实时监控互联网数据，当有符合监控条件的数据时，将推送到你的电脑和手机进行提醒。</div>
          <div>2.目前，可免费配置的关键词上限为9个。如不够，请联系管理员增加。</div>
        </div>
      </van-tab>

      <van-tab title="新增概念提醒" name="tab_xinzenggainian">
        <div class="checkbox_zone mgt20">
          除去<van-checkbox v-model="tab_xinzenggainian.filter_beijiaosuo">北交</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.filter_kechuang">科创</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.filter_chuangye">创业</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.filter_zhongxiao">深中小</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.filter_zhuban">沪主</van-checkbox>
        </div>
        <div class="checkbox_zone mgt20">
          仅限于<van-checkbox v-model="tab_xinzenggainian.filter_st">非ST</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.only_not_rongzi">非融</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.only_zhuanzhai">转债</van-checkbox>
          <van-checkbox v-model="tab_xinzenggainian.only_new_stock">次新</van-checkbox>
        </div>
        <div class="mgt20">
          <van-field v-model="tab_xinzenggainian.liutong_shizhi" label="N亿内市值" label-width="120px" placeholder="N亿内市值" type="digit" maxlength="5"/>
        </div>
        <div class="mgt20">
          <van-field v-for="(item, index) in tab_xinzenggainian.keywords" v-model="tab_xinzenggainian.keywords[index]" :key="index"
                     :label="`新增概念名称${index+1}`" label-width="120px" placeholder="输入概念名称，支持模糊匹配。" maxlength="20" right-icon="cross"
                     @click-right-icon="removeInput(tab_xinzenggainian.keywords, index)" @input="onInput(tab_xinzenggainian.keywords, index)"/>
        </div>
        <div class="add_input" v-if="tab_xinzenggainian.keywords.length < 99">
            <span @click="addInput(tab_xinzenggainian.keywords)">添加一组</span>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabXinzengGainianSave" round type="primary">保存</van-button>
          <van-button @click="onTabXinzengGainianCancel"  round type="default">取消</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>声明：</div>
          <div>1.实时监控互联网数据，当有符合监控条件的数据时，将推送到你的电脑和手机进行提醒。</div>
          <div>2.目前，可免费配置的关键词上限为9个。如不够，请联系管理员增加。</div>
        </div>
      </van-tab>

      <van-tab title="其他提醒" name="tab_other" v-show="!login_data">
        <div class="mgt20">
          <van-field v-model="tab_other.cailianshe_keywords" type="textarea" rows="10" label="CLS关键词" label-width="120px" placeholder="输入CLS关键词"/>
        </div>
        <div class="mgt20">
          <van-field v-model="tab_other.ipo_keywords" type="textarea" rows="10" label="IPO关键词" label-width="120px" placeholder="输入IPO关键词"/>
        </div>
      </van-tab>

      <van-tab title="大V发帖提醒" name="tab_dv">
        <div class="radio_zone mgt20">
            <van-radio-group direction="horizontal">
              <van-radio>韭菜公社</van-radio>
              <van-radio>淘股吧</van-radio>
              <van-radio>雪球</van-radio>
            </van-radio-group>
        </div>
        <div class="mgt20">
          <van-field label="大V名称" label-width="120px" placeholder="请输入大V名称" maxlength="50" right-icon="cross"/>
        </div>
        <div class="btn_zone mgt20">
          <van-button round type="primary">保存</van-button>
          <van-button round type="default">取消</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>声明：</div>
          <div>1.实时监控互联网数据，当有符合监控条件的数据时，将推送到你的电脑和手机进行提醒。</div>
          <div>2.目前，可免费配置的关键词上限为9个。如不够，请联系管理员增加。</div>
        </div>
      </van-tab>

<!--
      <van-tab title="小圈子">
        <div class="mgt20">
          <van-field v-model="tab_qz.lm_name" label="LM" placeholder="请输入文本" maxlength="20"/>
        </div>
        <div class="mgt20">
          <van-field v-model="tab_qz.ls_name" label="LS" placeholder="请输入文本" maxlength="20"/>
        </div>
        <div class="mgt20">
          <van-field v-model="tab_qz.exp_dt" label="DT" placeholder="请输入文本" maxlength="20"/>
        </div>
        <div class="mgt20">
          <van-field v-model="tab_qz.trial_code" label="身份识别码" placeholder="请输入文本" maxlength="6"/>
          <van-field v-model="tab_qz.amount" label="金额" placeholder="请输入文本" type="digit" maxlength="5"/>
          <van-field v-model="tab_qz.years" label="年限" placeholder="请输入文本" maxlength="20"/>
        </div>
        <div class="radio_zone mgt20">
            <van-radio-group v-model="tab_qz.soft_version" direction="horizontal">
              <van-radio name="PLUS">PLUS版</van-radio>
              <van-radio name="PRO">PRO版</van-radio>
            </van-radio-group>
        </div>
        <div class="btn_zone mgt20">
          <van-button @click="onTabQzSave" round type="primary">保存</van-button>
          <van-button @click="onTabQzCancel"  round type="default">重置</van-button>
          <van-button @click="onTabQzExp"  round type="default">EXP</van-button>
        </div>
        <div class="tip_zone mgt20">
          <div>小圈子使用说明：</div>
          <div>1.本功能仅限内部使用</div>
        </div>
      </van-tab>
-->
    </van-tabs>
  </div>
</template>

<script>
import {Field, Tab, Tabs, Checkbox, CheckboxGroup, RadioGroup, Radio, Button, Notify, Divider, Overlay, Loading, DropdownMenu, DropdownItem, Row, Col} from 'vant';

export default {
  components: {
    [Field.name]: Field,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  data() {
    return {
      loading: true,
      login_data: true,
      // =================================
      // 本地调试时，替换
      local_env: false,
      login_status: "needLogin",
//      local_env: true,
//      login_status: "alreadyLogin",
      // =================================
      // activeTab: this.login_data ? "tab_ty_hudong_search" : "tab_ty_wx_search",
      activeTab: "tab_ty_hudong_search",
      tmm: "hwh4J_2P9qaloG5VTNF_xkm9iRZIyuLF7H_Wt19lzTw=",
      keywords_history: [],
      xinde_result: [],
      search_keyword: "",
      easter_egg: "wu",
      stock_name: "",
      address: "",
      tags: "",
      diejia_gn_list: "",
      diejia_hy_list: "",
      main_business: "",
      gn_name: "",
      show_care_gn_type: "0",
      title1: '概念',
      option1: [],
      show1: false,
      titleHy1: '申万行业',
      optionHy1: [],
      showHy1: false,
      title2: '概念',
      option2: [],
      show2: false,
      expandedIndex: -1,
      tab_kuaijie: {
        keyword: '',
        hudong_flag: 1,
        wx_flag: '1',
        gonggao_flag: '1',
        tonghuashun_flag: 0,
        jiucaigongshe_flag: 0,
        gov_flag: 0,
        cailianshe_flag: 0,
        ipo_flag: 0,
      },
      tab_hudong: {
        keywords: ["","",""],
        filter_beijiaosuo: 0,
        filter_kechuang: 0,
        filter_zhuban: 0,
        filter_chuangye: 0,
        filter_zhongxiao: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        in_sentence: '1',
        filter_fouding: '0',
        filter_liutong: 1,
        liutong_shizhi: 99999,
        filter_days: 1,
        days_enable: 7,
        dingyue_status: 0,
      },
      tab_wx: {
        keywords: ["","",""],
        filter_beijiaosuo: 0,
        filter_kechuang: 0,
        filter_zhuban: 0,
        filter_chuangye: 0,
        filter_zhongxiao: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        in_sentence: '1',
        filter_fouding: '0',
        filter_liutong: 1,
        liutong_shizhi: 99999,
        filter_days: 1,
        days_enable: 7,
        dingyue_status: 0,
      },
      tab_gonggao: {
        keywords: ["","",""],
        filter_beijiaosuo: 0,
        filter_kechuang: 0,
        filter_zhuban: 0,
        filter_chuangye: 0,
        filter_zhongxiao: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        in_sentence: '1',
        filter_fouding: '0',
        filter_liutong: 1,
        liutong_shizhi: 99999,
        filter_days: 1,
        days_enable: 7,
        dingyue_status: 0,
      },
      tab_xinzenggainian: {
        keywords: ["","",""],
        filter_beijiaosuo: 0,
        filter_kechuang: 0,
        filter_zhuban: 0,
        filter_chuangye: 0,
        filter_zhongxiao: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        in_sentence: '1',
        filter_fouding: '0',
        filter_liutong: 1,
        liutong_shizhi: 99999,
        filter_days: 1,
        days_enable: 7,
        dingyue_status: 0,
      },
      tab_ty_hudong_search: {
        biz_type: "HUDONG",
        stock_code: "",
        stock_name: "",
        address: "",
        tags: "",
        diejia_gn_list: "",
        diejia_hy_list: "",
        main_business: "",
        zhuying_percent: "",
        holder_customer: "",
        waixiao_percent: "",
        days_enable: 7,
        gn_name: "",
        show_care_gn_type: "0",
        filter_zhongxiao: 0,
        filter_chuangye: 0,
        filter_zhuban: 0,
        filter_kechuang: 0,
        filter_beijiaosuo: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        liutong_shizhi: 99999,
        pub_time_sort_type: 'nearly',
        order_by_gn_pub_time: 1,
        in_sentence: '1',
        filter_fouding: '0',
        show_zhangfu: 0,
        filter_days: 1,
        filter_liutong: 1,
        dingyue_status: 0,
        juhe: 1,
        sort_by: '',
        fast_search_type: 'BEIJIAO',
        fast_filter_type: '',
        fast_label_type: '',
        tip: '',
        page: 1,
        page_size: 10,
      },
      tab_ty_hudong_search_result: {
        total_length: 0,
        stock_number: 0,
        stock_list:[],
        analysis_result: []
      },
      tab_ty_wx_search: {
        biz_type: "WX",
        stock_code: "",
        stock_name: "",
        address: "",
        tags: "",
        diejia_gn_list: "",
        diejia_hy_list: "",
        main_business: "",
        zhuying_percent: "",
        holder_customer: "",
        waixiao_percent: "",
        days_enable: 7,
        gn_name: "",
        show_care_gn_type: "0",
        filter_zhongxiao: 0,
        filter_chuangye: 0,
        filter_zhuban: 0,
        filter_kechuang: 0,
        filter_beijiaosuo: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        liutong_shizhi: 99999,
        pub_time_sort_type: 'nearly',
        order_by_gn_pub_time: 1,
        in_sentence: '1',
        filter_fouding: '0',
        show_zhangfu: 0,
        filter_days: 1,
        filter_liutong: 1,
        dingyue_status: 0,
        juhe: 1,
        sort_by: '',
        fast_search_type: 'BEIJIAO',
        fast_filter_type: '',
        fast_label_type: '',
        tip: '',
        page: 1,
        page_size: 10,
      },
      tab_ty_wx_search_result: {
        total_length: 0,
        stock_number: 0,
        stock_list:[],
        analysis_result: []
      },
      tab_ty_gonggao_search: {
        biz_type: "GONGGAO",
        stock_code: "",
        stock_name: "",
        tags: "",
        diejia_gn_list: "",
        diejia_hy_list: "",
        main_business: "",
        zhuying_percent: "",
        holder_customer: "",
        waixiao_percent: "",
        days_enable: 7,
        gn_name: "",
        show_care_gn_type: "0",
        filter_zhongxiao: 0,
        filter_chuangye: 0,
        filter_zhuban: 0,
        filter_kechuang: 0,
        filter_beijiaosuo: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        liutong_shizhi: 99999,
        pub_time_sort_type: 'nearly',
        order_by_gn_pub_time: 1,
        in_sentence: '1',
        filter_fouding: '0',
        show_zhangfu: 0,
        filter_days: 1,
        filter_liutong: 1,
        dingyue_status: 0,
        juhe: 1,
        sort_by: '',
        fast_search_type: 'BEIJIAO',
        fast_filter_type: '',
        fast_label_type: '',
        tip: '',
        page: 1,
        page_size: 10,
      },
      tab_ty_gonggao_search_result: {
        total_length: 0,
        stock_number: 0,
        stock_list:[],
        analysis_result: []
      },
      tab_jiucaigongshe: {
        keywords: ["","",""],
        filter_beijiaosuo: 0,
        filter_kechuang: 0,
        filter_zhuban: 0,
        filter_chuangye: 0,
        filter_zhongxiao: 0,
        filter_st: 0,
        only_zhuanzhai: 0,
        only_new_stock: 0,
        only_not_rongzi: 0,
        in_sentence: '1',
        filter_fouding: '0',
        filter_liutong: 1,
        liutong_shizhi: 99999,
        filter_days: 1,
        days_enable: 7,
        dingyue_status: 0,
      },
      tab_other: {
        cailianshe_keywords: '',
        ipo_keywords: '',
      },
    }
  },
  mounted() {
    this.login_auth_fs();
  },
  methods: {
    login_auth_fs() {
      // loading=true 已在 data() 中初始化，首帧即遮罩
      // =================================
      // 必须在飞书中打开
      if (!this.local_env) {
        if (!window.h5sdk) {
          window.console.log('请在飞书中打开网页');
          alert('请在飞书中打开网页');
          window.location.href = "http://43.143.184.136:33080";
          return;
        }
      }
      // =================================
      // 本地调试模式：直接 fetchData
      if (this.login_status === "alreadyLogin") {
        this.fetchData();
        return;
      }
      // =================================
      // 免登：h5sdk.ready() 后直接调 tt.requestAuthCode()，无页面跳转，无需 h5sdk.config()
      const e_id = this.get_e_id();
      if (!e_id) {
        this.loading = false;
        alert('URL 缺少 e_id 参数，请检查飞书应用页面 URL 配置');
        return;
      }
      window.h5sdk.ready(() => {
        window.tt.requestAuthCode({
          appId: 'cli_' + e_id,
          success: (res) => {
            // 用授权码换取用户身份（唯一1次服务端调用）
            this.$axios.get('/api/callback/fs/login/auth?e_id=' + this.get_e_id() + '&code=' + res.code)
              .then(response => {
                this.login_data = response.data['data'];
                this.login_status = "alreadyLogin";
                // check_device_info 是异步的，不阻塞 fetchData，两者并发执行
                if (!this.local_env) {
                  this.check_device_info();
                }
                this.fetchData();
              })
              .catch(error => {
                this.loading = false;
                this.handleException(error);
              });
          },
          fail: (err) => {
            this.loading = false;
            window.console.log('requestAuthCode 失败', JSON.stringify(err));
            alert('飞书登录失败: ' + JSON.stringify(err));
          }
        });
      });
    },
    get_e_id() {
      return new URLSearchParams(window.location.search).get('e_id');
    },
    check_device_info() {
        // 调用config接口的当前网页url
        const url = encodeURIComponent(location.href.split("#")[0]);
        window.console.log("接入方前端将需要鉴权的url发给接入方服务端,url为:", url);
        // 向接入方服务端发起请求，获取鉴权参数（appId、timestamp、nonceStr、signature）
        this.$axios.get('/api/user/login/get_config_parameters/fs?url='+url+'&e_id='+this.get_e_id())
            .then(response => {
                // 接入方服务端返回给接入方前端的结果(前端调用config接口的所需参数)
                // 调用config接口进行鉴权
//                // 通过error接口处理API验证失败后的回调
//                window.h5sdk.error((err) => {
//                  throw ("h5sdk error:", JSON.stringify(err));
//                });
                window.h5sdk.config({
                  appId: response.data['data']['app_id'],
                  timestamp: response.data['data']['timestamp'],
                  nonceStr: response.data['data']['nonce_str'],
                  signature: response.data['data']['signature'],
                  jsApiList: [],
                  //鉴权成功回调
                  onSuccess: (res) => {
                    window.console.log(`config success: ${JSON.stringify(res)}`);
                  },
                  //鉴权失败回调
                  onFail: (err) => {
                    alert(JSON.stringify(err))
                    throw `config failed: ${JSON.stringify(err)}`;
                  },
                });
                // 完成鉴权后，便可在 window.h5sdk.ready 里调用 JSAPI
                window.h5sdk.ready(() => {
                  // window.h5sdk.ready回调函数在环境准备就绪时触发
                  window.tt.getSystemInfo({
                    success(res) {
                      window.console.log(JSON.stringify(res));
                      // 核验登录设备信息
                      fetch('/api/user/device/check', {
                            method: 'post',
                            body: JSON.stringify(res),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                          })
                          .then((response) =>
                          response.json().then((res) => {
                              // 接入方服务端返回给接入方前端的结果(前端调用config接口的所需参数)
                              // 调用config接口进行鉴权
                              if (res['code'] !== '0') {
                                  // 登录设备不一致，则关闭应用窗口
                                  window.tt.showModal({
                                      title: '登录设备异常',
                                      content: res['data'],
                                      confirmText: '确定',
                                      cancelText: '取消',
                                      success(res) {
                                        window.console.log('showModal 调用成功', res);
                                      },
                                      fail(res) {
                                        window.console.log('showModal 调用失败', res.errMsg);
                                      },
                                      complete(res) {
                                        // 关闭应用窗口
                                        window.tt.closeWindow();
                                        window.console.log('showModal 调用结束', res.errMsg);
                                      }
                                    });
                              }
                          }))
                          .catch(error => {
                            alert(0)
                            alert(error);
                            this.handleException(error);
                          });
                    },
                    fail(err) {
                      window.console.log(`getSystemInfo fail: ${JSON.stringify(err)}`);
                      alert(`getSystemInfo fail: ${JSON.stringify(err)}`);
                    },
                  });
                });
            })
            .catch(error => {
              alert(error);
              this.handleException(error);
            });
    },
    handleResponse_list(response) {
      if (response.data['code'] === '0'){
        Notify({ type: 'success', duration:300, message: '查询成功' });
        this.keywords_history = response.data['keywords_history']
        return response.data['data']
      } else {
        Notify({ type: 'warning', duration:3000, message: '查询失败，'+response.data['data'] });
        return ''
      }
    },
    handleResponse_save(response) {
      if (response.data['code'] === '0'){
        Notify({ type: 'success', duration:300, message: '保存成功' });
        // 刷新页面
        this.fetchData();
      } else {
        Notify({ type: 'warning', duration:3000, message: '保存失败，'+response.data['data'] });
      }
    },
    handleException(error){
        Notify({ type: 'danger', duration:3000, message: error });
    },
    applyItems(items) {
      for (var i = 0; i < items.length; i++) {
        if (items[i]['biz_type'] === 'HUDONG') {
            this.tab_hudong.keywords = this.transKeywords(items[i]['keywords']).split(',')
            this.tab_hudong.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_hudong.filter_kechuang = items[i]['filter_kechuang']
            this.tab_hudong.filter_zhuban = items[i]['filter_zhuban']
            this.tab_hudong.filter_chuangye = items[i]['filter_chuangye']
            this.tab_hudong.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_hudong.filter_st = items[i]['filter_st']
            this.tab_hudong.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_hudong.only_new_stock = items[i]['only_new_stock']
            this.tab_hudong.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_hudong.in_sentence = ''+items[i]['in_sentence']
            this.tab_hudong.filter_fouding = items[i]['filter_fouding']
            this.tab_hudong.filter_liutong = items[i]['filter_liutong']
            this.tab_hudong.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_hudong.filter_days = items[i]['filter_days']
            this.tab_hudong.days_enable = items[i]['days_enable']
            this.tab_ty_hudong_search.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_ty_hudong_search.filter_kechuang = items[i]['filter_kechuang']
            this.tab_ty_hudong_search.filter_zhuban = items[i]['filter_zhuban']
            this.tab_ty_hudong_search.filter_chuangye = items[i]['filter_chuangye']
            this.tab_ty_hudong_search.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_ty_hudong_search.filter_st = items[i]['filter_st']
            this.tab_ty_hudong_search.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_ty_hudong_search.only_new_stock = items[i]['only_new_stock']
            this.tab_ty_hudong_search.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_ty_hudong_search.in_sentence = ''+items[i]['in_sentence']
            if (!this.login_data) {
                this.tab_ty_hudong_search.filter_fouding = '1'
            } else {
                this.tab_ty_hudong_search.filter_fouding = items[i]['filter_fouding']
            }
            if (!this.login_data) {
                this.tab_ty_hudong_search.pub_time_sort_type = 'first'
            }
            this.tab_ty_hudong_search.filter_liutong = items[i]['filter_liutong']
            this.tab_ty_hudong_search.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_ty_hudong_search.filter_days = items[i]['filter_days']
            this.tab_ty_hudong_search.days_enable = items[i]['days_enable']
        } else if (items[i]['biz_type'] === 'WX') {
            this.tab_wx.keywords = this.transKeywords(items[i]['keywords']).split(',')
            this.tab_wx.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_wx.filter_kechuang = items[i]['filter_kechuang']
            this.tab_wx.filter_zhuban = items[i]['filter_zhuban']
            this.tab_wx.filter_chuangye = items[i]['filter_chuangye']
            this.tab_wx.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_wx.filter_st = items[i]['filter_st']
            this.tab_wx.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_wx.only_new_stock = items[i]['only_new_stock']
            this.tab_wx.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_wx.in_sentence = ''+items[i]['in_sentence']
            this.tab_wx.filter_fouding = items[i]['filter_fouding']
            this.tab_wx.filter_liutong = items[i]['filter_liutong']
            this.tab_wx.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_wx.filter_days = items[i]['filter_days']
            this.tab_wx.days_enable = items[i]['days_enable']
            this.tab_ty_wx_search.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_ty_wx_search.filter_kechuang = items[i]['filter_kechuang']
            this.tab_ty_wx_search.filter_zhuban = items[i]['filter_zhuban']
            this.tab_ty_wx_search.filter_chuangye = items[i]['filter_chuangye']
            this.tab_ty_wx_search.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_ty_wx_search.filter_st = items[i]['filter_st']
            this.tab_ty_wx_search.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_ty_wx_search.only_new_stock = items[i]['only_new_stock']
            this.tab_ty_wx_search.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_ty_wx_search.in_sentence = ''+items[i]['in_sentence']
            this.tab_ty_wx_search.filter_fouding = items[i]['filter_fouding']
            if (!this.login_data) {
                this.tab_ty_wx_search.pub_time_sort_type = 'nearly'
            }
            this.tab_ty_wx_search.filter_liutong = items[i]['filter_liutong']
            this.tab_ty_wx_search.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_ty_wx_search.filter_days = items[i]['filter_days']
            this.tab_ty_wx_search.days_enable = items[i]['days_enable']
        } else if (items[i]['biz_type'] === 'GONGGAO') {
            this.tab_gonggao.keywords = this.transKeywords(items[i]['keywords']).split(',')
            this.tab_gonggao.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_gonggao.filter_kechuang = items[i]['filter_kechuang']
            this.tab_gonggao.filter_zhuban = items[i]['filter_zhuban']
            this.tab_gonggao.filter_chuangye = items[i]['filter_chuangye']
            this.tab_gonggao.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_gonggao.filter_st = items[i]['filter_st']
            this.tab_gonggao.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_gonggao.only_new_stock = items[i]['only_new_stock']
            this.tab_gonggao.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_gonggao.in_sentence = ''+items[i]['in_sentence']
            this.tab_gonggao.filter_fouding = items[i]['filter_fouding']
            this.tab_gonggao.filter_liutong = items[i]['filter_liutong']
            this.tab_gonggao.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_gonggao.filter_days = items[i]['filter_days']
            this.tab_gonggao.days_enable = items[i]['days_enable']
            this.tab_ty_gonggao_search.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_ty_gonggao_search.filter_kechuang = items[i]['filter_kechuang']
            this.tab_ty_gonggao_search.filter_zhuban = items[i]['filter_zhuban']
            this.tab_ty_gonggao_search.filter_chuangye = items[i]['filter_chuangye']
            this.tab_ty_gonggao_search.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_ty_gonggao_search.filter_st = items[i]['filter_st']
            this.tab_ty_gonggao_search.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_ty_gonggao_search.only_new_stock = items[i]['only_new_stock']
            this.tab_ty_gonggao_search.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_ty_gonggao_search.in_sentence = ''+items[i]['in_sentence']
            this.tab_ty_gonggao_search.filter_fouding = items[i]['filter_fouding']
            if (!this.login_data) {
                this.tab_ty_gonggao_search.pub_time_sort_type = 'nearly'
            }
            this.tab_ty_gonggao_search.filter_liutong = items[i]['filter_liutong']
            this.tab_ty_gonggao_search.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_ty_gonggao_search.filter_days = items[i]['filter_days']
            this.tab_ty_gonggao_search.days_enable = items[i]['days_enable']
        } else if (items[i]['biz_type'] === 'THS') {
            this.tab_xinzenggainian.keywords = this.transKeywords(items[i]['keywords']).split(',')
            this.tab_xinzenggainian.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_xinzenggainian.filter_kechuang = items[i]['filter_kechuang']
            this.tab_xinzenggainian.filter_zhuban = items[i]['filter_zhuban']
            this.tab_xinzenggainian.filter_chuangye = items[i]['filter_chuangye']
            this.tab_xinzenggainian.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_xinzenggainian.filter_st = items[i]['filter_st']
            this.tab_xinzenggainian.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_xinzenggainian.only_new_stock = items[i]['only_new_stock']
            this.tab_xinzenggainian.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_xinzenggainian.in_sentence = ''+items[i]['in_sentence']
            this.tab_xinzenggainian.filter_fouding = items[i]['filter_fouding']
            this.tab_xinzenggainian.filter_liutong = items[i]['filter_liutong']
            this.tab_xinzenggainian.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_xinzenggainian.filter_days = items[i]['filter_days']
            this.tab_xinzenggainian.days_enable = items[i]['days_enable']
        } else if (items[i]['biz_type'] === 'JIUCAI_GONGSHE') {
            this.tab_jiucaigongshe.keywords = this.transKeywords(items[i]['keywords']).split(',')
            this.tab_jiucaigongshe.filter_beijiaosuo = items[i]['filter_beijiaosuo']
            this.tab_jiucaigongshe.filter_kechuang = items[i]['filter_kechuang']
            this.tab_jiucaigongshe.filter_zhuban = items[i]['filter_zhuban']
            this.tab_jiucaigongshe.filter_chuangye = items[i]['filter_chuangye']
            this.tab_jiucaigongshe.filter_zhongxiao = items[i]['filter_zhongxiao']
            this.tab_jiucaigongshe.filter_st = items[i]['filter_st']
            this.tab_jiucaigongshe.only_zhuanzhai = items[i]['only_zhuanzhai']
            this.tab_jiucaigongshe.only_new_stock = items[i]['only_new_stock']
            this.tab_jiucaigongshe.only_not_rongzi = items[i]['only_not_rongzi']
            this.tab_jiucaigongshe.in_sentence = ''+items[i]['in_sentence']
            this.tab_jiucaigongshe.filter_fouding = items[i]['filter_fouding']
            this.tab_jiucaigongshe.filter_liutong = items[i]['filter_liutong']
            this.tab_jiucaigongshe.liutong_shizhi = items[i]['liutong_shizhi']
            this.tab_jiucaigongshe.filter_days = items[i]['filter_days']
            this.tab_jiucaigongshe.days_enable = items[i]['days_enable']
        } else if (items[i]['biz_type'] === 'CLS') {
            this.tab_other.cailianshe_keywords = items[i]['keywords']
        } else if (items[i]['biz_type'] === 'IPO_Color') {
            this.tab_other.ipo_keywords = items[i]['keywords']
        }
      }
    },
    fetchData() {
      this.$axios.get('/api/user/dingyue/list')
        .then(response => {
          this.items = this.handleResponse_list(response);
          this.applyItems(this.items);
          this.activeTab = 'tab_ty_hudong_search';
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.handleException(error);
        });
    },
    transKeywords(keywords) {
      if (keywords.length > 0 && keywords[0] === ',') {
        keywords = keywords.substring(1,keywords.length)
      }
      if (keywords.length > 0 && keywords[keywords.length-1] === ',') {
        keywords = keywords.substring(0,keywords.length-1)
      }
      return keywords
    },
    addInput(keywords) {
      keywords.push("")
    },
    removeInput(keywords, index) {
      keywords.splice(index, 1)
    },
    onInput(keywords, index) {
      // 获取输入框的值
      let value = keywords[index];
      // 替换中文逗号为英文逗号
      value = value.replace(/，/g, ',');
      // 如果值中包含逗号，阻止其输入
      if (value.includes(',') || value.includes('，')) {
        keywords[index] = keywords[index].replace(/,|，/g, '');
      } else {
        keywords[index] = value;
      }
    },
    onTabKuaijieSave(oper_type) {
      this.$axios.post('/api/user/dingyue/keywords/save', {
        'oper_type':oper_type,
        'keyword':this.tab_kuaijie.keyword,
        'hudong_flag':this.tab_kuaijie.hudong_flag,
        'wx_flag':this.tab_kuaijie.wx_flag,
        'gonggao_flag':this.tab_kuaijie.gonggao_flag,
        'tonghuashun_flag':this.tab_kuaijie.tonghuashun_flag,
        'jiucaigongshe_flag':this.tab_kuaijie.jiucaigongshe_flag,
        'gov_flag':this.tab_kuaijie.gov_flag,
        'cailianshe_flag':this.tab_kuaijie.cailianshe_flag,
        'ipo_flag':this.tab_kuaijie.ipo_flag,
      })
      .then(response => {
          this.handleResponse_save(response);
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onBtnXindeClick(){
      this.$axios.get('/api/user/xinde/query')
      .then(response => {
          // 替换\n
          this.xinde_result = response.data['data'];
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onTabWxSave(){
      this.$axios.post('/api/user/dingyue/save?bizType=WX', this.tab_wx)
      .then(response => {
          this.handleResponse_save(response);
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onTabWxCancel(){
      this.fetchData();
      this.activeTab = "tab_wx";
    },
    onTabGonggaoSave(){
      this.$axios.post('/api/user/dingyue/save?bizType=GONGGAO', this.tab_gonggao)
      .then(response => {
          this.handleResponse_save(response);
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onTabGonggaoCancel(){
      this.fetchData();
      this.activeTab = "tab_gonggao";
    },
    onTabXinzengGainianSave(){
      this.$axios.post('/api/user/dingyue/save?bizType=THS', this.tab_xinzenggainian)
      .then(response => {
          this.handleResponse_save(response);
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onTabXinzengGainianCancel(){
      this.fetchData();
      this.activeTab = "tab_xinzenggainian";
    },
    onTabHudongSave() {
      this.$axios.post('/api/user/dingyue/save?bizType=HUDONG', this.tab_hudong)
      .then(response => {
          this.handleResponse_save(response);
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onTabHudongCancel(){
      this.fetchData();
      this.activeTab = "tab_hudong";
    },
    onTabJiucaiGongsheSave(){
      this.$axios.post('/api/user/dingyue/save?bizType=JIUCAI_GONGSHE', this.tab_jiucaigongshe)
      .then(response => {
          this.handleResponse_save(response);
      })
      .catch(error => {
          this.handleException(error);
      })
    },
    onTabJiucaiGongsheCancel(){
      this.fetchData();
      this.activeTab = "tab_jiucaigongshe";
    },
    assignment_common_params(tab_search) {
      tab_search.search_keyword = this.search_keyword;
      tab_search.easter_egg = this.easter_egg;
      tab_search.stock_name = this.stock_name;
      tab_search.address = this.address;
      tab_search.tags = this.tags;
      tab_search.diejia_gn_list = this.diejia_gn_list;
      tab_search.diejia_hy_list = this.diejia_hy_list;
      tab_search.main_business = this.main_business;
      tab_search.gn_name = this.gn_name;
      tab_search.show_care_gn_type = this.show_care_gn_type;
    },
    onBtnTyHudongSearch(){
      this.loading = true;
      this.expandedIndex = -1;
      this.assignment_common_params(this.tab_ty_hudong_search);
      this.$axios.post('/api/user/tianyan/query', this.tab_ty_hudong_search)
      .then(response => {
          this.loading = false;
          this.data = this.handleResponse_list(response);
          this.tab_ty_hudong_search_result.total_length = this.data.total_length
          this.tab_ty_hudong_search_result.stock_number = this.data.stock_number
          this.tab_ty_hudong_search_result.stock_list = this.data.stock_list
      })
      .catch(error => {
          this.loading = false;
          this.handleException(error);
      })
    },
    onBtnTyHudongReset(){
      this.fetchData();
      this.activeTab = "tab_ty_hudong_search";
    },
    onBtnTyHudongSearch_FirstPage(){
        this.tab_ty_hudong_search.page = 1;
        this.onBtnTyHudongSearch();
    },
    onBtnTyHudongSearch_PrePage(){
        this.tab_ty_hudong_search.page = Number(this.tab_ty_hudong_search.page) - 1;
        if (this.tab_ty_hudong_search.page < 1) {
          this.tab_ty_hudong_search.page = 1;
        }
        this.onBtnTyHudongSearch();
    },
    onBtnTyHudongSearch_NextPage(){
        this.tab_ty_hudong_search.page = Number(this.tab_ty_hudong_search.page) + 1;
        if (this.tab_ty_hudong_search.page > Math.ceil(this.tab_ty_hudong_search_result.stock_number/this.tab_ty_hudong_search.page_size)) {
          this.tab_ty_hudong_search.page = Math.ceil(this.tab_ty_hudong_search_result.stock_number/this.tab_ty_hudong_search.page_size);
        }
        this.onBtnTyHudongSearch();
    },
    onBtnTyHudongSearch_LastPage(){
        this.tab_ty_hudong_search.page = Math.ceil(this.tab_ty_hudong_search_result.stock_number/this.tab_ty_hudong_search.page_size);
        this.onBtnTyHudongSearch();
    },
    onBtnTyWxSearch(){
      this.loading = true;
      this.expandedIndex = -1;
      this.assignment_common_params(this.tab_ty_wx_search);
      this.$axios.post('/api/user/tianyan/query', this.tab_ty_wx_search)
      .then(response => {
          this.loading = false;
          this.data = this.handleResponse_list(response);
          this.tab_ty_wx_search_result.total_length = this.data.total_length
          this.tab_ty_wx_search_result.stock_number = this.data.stock_number
          this.tab_ty_wx_search_result.stock_list = this.data.stock_list
      })
      .catch(error => {
          this.loading = false;
          this.handleException(error);
      })
    },
    onBtnTyWxReset(){
      this.fetchData();
      this.activeTab = "tab_ty_wx_search";
    },
    onBtnTyWxSearch_FirstPage(){
        this.tab_ty_wx_search.page = 1;
        this.onBtnTyWxSearch();
    },
    onBtnTyWxSearch_PrePage(){
        this.tab_ty_wx_search.page = Number(this.tab_ty_wx_search.page) - 1;
        if (this.tab_ty_wx_search.page < 1) {
          this.tab_ty_wx_search.page = 1;
        }
        this.onBtnTyWxSearch();
    },
    onBtnTyWxSearch_NextPage(){
        this.tab_ty_wx_search.page = Number(this.tab_ty_wx_search.page) + 1;
        if (this.tab_ty_wx_search.page > Math.ceil(this.tab_ty_wx_search_result.stock_number/this.tab_ty_wx_search.page_size)) {
          this.tab_ty_wx_search.page = Math.ceil(this.tab_ty_wx_search_result.stock_number/this.tab_ty_wx_search.page_size);
        }
        this.onBtnTyWxSearch();
    },
    onBtnTyWxSearch_LastPage(){
        this.tab_ty_wx_search.page = Math.ceil(this.tab_ty_wx_search_result.stock_number/this.tab_ty_wx_search.page_size);
        this.onBtnTyWxSearch();
    },
    onBtnTyGonggaoSearch(){
      this.loading = true;
      this.expandedIndex = -1;
      this.assignment_common_params(this.tab_ty_gonggao_search);
      this.$axios.post('/api/user/tianyan/query', this.tab_ty_gonggao_search)
      .then(response => {
          this.loading = false;
          this.data = this.handleResponse_list(response);
          this.tab_ty_gonggao_search_result.total_length = this.data.total_length
          this.tab_ty_gonggao_search_result.stock_number = this.data.stock_number
          this.tab_ty_gonggao_search_result.stock_list = this.data.stock_list
      })
      .catch(error => {
          this.loading = false;
          this.handleException(error);
      })
    },
    onBtnTyGonggaoReset(){
      this.fetchData();
      this.activeTab = "tab_ty_gonggao_search";
    },
    onBtnTyGonggaoSearch_FirstPage(){
        this.tab_ty_gonggao_search.page = 1;
        this.onBtnTyGonggaoSearch();
    },
    onBtnTyGonggaoSearch_PrePage(){
        this.tab_ty_gonggao_search.page = Number(this.tab_ty_gonggao_search.page) - 1;
        if (this.tab_ty_gonggao_search.page < 1) {
          this.tab_ty_gonggao_search.page = 1;
        }
        this.onBtnTyGonggaoSearch();
    },
    onBtnTyGonggaoSearch_NextPage(){
        this.tab_ty_gonggao_search.page = Number(this.tab_ty_gonggao_search.page) + 1;
        if (this.tab_ty_gonggao_search.page > Math.ceil(this.tab_ty_gonggao_search_result.stock_number/this.tab_ty_gonggao_search.page_size)) {
          this.tab_ty_gonggao_search.page = Math.ceil(this.tab_ty_gonggao_search_result.stock_number/this.tab_ty_gonggao_search.page_size);
        }
        this.onBtnTyGonggaoSearch();
    },
    onBtnTyGonggaoSearch_LastPage(){
        this.tab_ty_gonggao_search.page = Math.ceil(this.tab_ty_gonggao_search_result.stock_number/this.tab_ty_gonggao_search.page_size);
        this.onBtnTyGonggaoSearch();
    },
    handleInput1() {
      this.option1 = []
      if (this.diejia_gn_list !== '') {
        let jia_index = this.diejia_gn_list.lastIndexOf('+')
        let kong_index = this.diejia_gn_list.lastIndexOf(' ')
        this.$axios.get('/api/user/concept/list?keyword='+this.diejia_gn_list.substring(Math.max(jia_index, kong_index)+1, this.diejia_gn_list.length))
          .then(response => {
            for (var i = 0; i < response.data['data'].length; i++) {
              this.option1[i] = {"text": response.data['data'][i], "value": response.data['data'][i]}
              if (i === 0) {
                this.title1 = response.data['data'][i]
              }
            }
            this.show1 = true
        })
        .catch(error => {
          this.handleException(error);
        });
      }
    },
    handelChange1(value){
      this.title1 = this.option1.filter(item => item.value === value)[0].text
      if (this.diejia_gn_list.lastIndexOf('+') === -1 & this.diejia_gn_list.lastIndexOf(' ') === -1) {
        this.diejia_gn_list = this.title1
      } else {
        let jia_index = this.diejia_gn_list.lastIndexOf('+')
        let kong_index = this.diejia_gn_list.lastIndexOf(' ')
        this.diejia_gn_list = this.diejia_gn_list.substring(0, Math.max(jia_index, kong_index)+1) + this.title1
      }
    },
    handleInputHy1() {
      this.optionHy1 = []
      if (this.diejia_hy_list !== '') {
        let jia_index = this.diejia_hy_list.lastIndexOf('+')
        let kong_index = this.diejia_hy_list.lastIndexOf(' ')
        this.$axios.get('/api/user/hangye/list?keyword='+this.diejia_hy_list.substring(Math.max(jia_index, kong_index)+1, this.diejia_hy_list.length))
          .then(response => {
            for (var i = 0; i < response.data['data'].length; i++) {
              this.optionHy1[i] = {"text": response.data['data'][i], "value": response.data['data'][i]}
              if (i === 0) {
                this.titleHy1 = response.data['data'][i]
              }
            }
            this.showHy1 = true
        })
        .catch(error => {
          this.handleException(error);
        });
      }
    },
    handelChangeHy1(value){
      this.titleHy1 = this.optionHy1.filter(item => item.value === value)[0].text
      if (this.diejia_hy_list.lastIndexOf('+') === -1 & this.diejia_hy_list.lastIndexOf(' ') === -1) {
        this.diejia_hy_list = this.titleHy1
      } else {
        let jia_index = this.diejia_hy_list.lastIndexOf('+')
        let kong_index = this.diejia_hy_list.lastIndexOf(' ')
        this.diejia_hy_list = this.diejia_hy_list.substring(0, Math.max(jia_index, kong_index)+1) + this.titleHy1
      }
    },
    handleInput2() {
      this.option2 = []
      if (this.gn_name !== '') {
        let jia_index = this.gn_name.lastIndexOf('+')
        let kong_index = this.gn_name.lastIndexOf(' ')
        this.$axios.get('/api/user/concept/list?keyword='+this.gn_name.substring(Math.max(jia_index, kong_index)+1, this.gn_name.length))
          .then(response => {
            for (var i = 0; i < response.data['data'].length; i++) {
              this.option2[i] = {"text": response.data['data'][i], "value": response.data['data'][i]}
              if (i === 0) {
                this.title2 = response.data['data'][i]
              }
            }
            this.show2 = true
        })
        .catch(error => {
          this.handleException(error);
        });
      }
    },
    handelChange2(value){
      this.title2 = this.option2.filter(item => item.value === value)[0].text
      if (this.gn_name.lastIndexOf('+') === -1 & this.gn_name.lastIndexOf(' ') === -1) {
        this.gn_name = this.title2
      } else {
        let jia_index = this.gn_name.lastIndexOf('+')
        let kong_index = this.gn_name.lastIndexOf(' ')
        this.gn_name = this.gn_name.substring(0, Math.max(jia_index, kong_index)+1) + this.title2
      }
    },
    seeTyDetail(event, index) {
        // 获取点击元素
        const element = event.currentTarget;
        // 记录点击前元素相对于视口顶部的偏移量
        const initialOffsetTop = element.getBoundingClientRect().top;

        // 展开或关闭
        if (this.expandedIndex === index) {
            this.expandedIndex = -1; // 点击已展开的 item 则关闭
        } else {
            this.expandedIndex = index; // 点击其他 item 则展开该 item 并关闭其他
        }

        // 在 DOM 更新后进行滚动调整
        this.$nextTick(() => {
            // 重新获取元素相对于视口顶部的偏移量
            const newOffsetTop = element.getBoundingClientRect().top;
            // 计算滚动差值
            const scrollDiff = newOffsetTop - initialOffsetTop;
            // 调整滚动位置
            window.scrollBy(0, scrollDiff);
        });
    },
  }

};
</script>

<style lang="less">
.mgt20 {
  margin: 10px 0;
}

.add_input {
  text-align: right;
  margin: 0 10px;
}

.checkbox_zone {
  display: flex;
  justify-content: left;
}

.radio_zone {
  display: flex;
  justify-content: left;
}

.btn_zone {
  display: flex;
  justify-content: space-around;

  button {
    width: 100px
  }
}

.tip_zone {
  margin: 10px;
}

p {
  margin: 0 10px;
  padding: 0;
}

.even-item {
  background-color: #FDEDEC; /* 偶数行背景色，粉色 */
  padding: 10px 0px;
}

.odd-item {
  background-color: #EAFAF1; /* 奇数行背景色，绿色 */
  padding: 10px 0px;
}

.blue-label .van-radio__label {
  color: #2ab5e6;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.tag-item {
  font-size: 10px;
  color: #ff9800;
  margin-left: 2px;
  padding: 0 2px;
  background-color: #fff3e0;
  border-radius: 2px;
}

</style>
